import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/shop', label: 'Boutique' },
  { to: '/about', label: 'À propos' },
  { to: '/contact', label: 'Contact' },
];

const customerLinks = [
  { to: '/account', label: 'Compte' },
  { to: '/cart', label: 'Panier' },
  { to: '/checkout', label: 'Paiement' },
];

export default function Footer() {
  return (
    <footer className="border-t border-leather-200/70 bg-leather-900 text-cream-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 lg:grid-cols-[2fr_1fr_1fr]">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-gold-500 text-sm font-bold text-leather-900">
              ST
            </span>
            <div>
              <p className="font-display text-lg font-semibold">Sellerie Thaïs</p>
              <p className="text-sm text-cream-200">Atelier de cuir français</p>
            </div>
          </div>
          <p className="max-w-sm text-sm text-cream-200">
            Colliers et accessoires en cuir finis à la main, réalisés en petites séries avec des peaux
            premium et des détails intemporels.
          </p>
          <div className="text-sm text-cream-200">
            <p>contact@sellerie-thais.fr</p>
            <p>+33 1 84 88 00 00</p>
          </div>
        </div>

        <div className="space-y-3 text-sm">
          <p className="font-semibold uppercase tracking-wide text-cream-100">Atelier</p>
          <div className="flex flex-col gap-2 text-cream-200">
            {quickLinks.map((link) => (
              <Link key={link.to} to={link.to} className="transition hover:text-cream-50">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="space-y-3 text-sm">
          <p className="font-semibold uppercase tracking-wide text-cream-100">Client</p>
          <div className="flex flex-col gap-2 text-cream-200">
            {customerLinks.map((link) => (
              <Link key={link.to} to={link.to} className="transition hover:text-cream-50">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-leather-800">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs text-cream-300 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <span>© 2024 Sellerie Thaïs. Tous droits réservés.</span>
          <span>Fabriqué en France - Confectionné à la main</span>
        </div>
      </div>
    </footer>
  );
}
